import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonModule as NimbusCommonModule } from '../../common/common.module';
import { SocialModule } from '../../social';
import { LoginModule } from '../../login';
import { HeaderModule } from '../../header';

import { TopComponent } from './top.component';
import { TopActionComponent } from './top-action.component';
import { ViewButtonComponent } from './view-button.component';
import { BreadcumbsComponent } from './breadcumbs.component';
import { DateComponent } from './date.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    LoginModule,
    RouterModule,
    SocialModule,
    HeaderModule
  ],
  declarations: [
    TopComponent,
    TopActionComponent,
    BreadcumbsComponent,
    DateComponent,
    ViewButtonComponent
  ],
  exports: [
    TopComponent,
    TopActionComponent
  ]
})
export class TopModule { }
